import { Component, OnInit } from '@angular/core';
import confetti from '@hiseb/confetti';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityStoreService } from 'src/app/core/store/activity-store.service';

@Component({
  selector: 'app-submit-proof-thank-you-dialog',
  templateUrl: './submit-proof-thank-you-dialog.component.html',
  styleUrls: ['./submit-proof-thank-you-dialog.component.scss'],
})
export class SubmitProofThankYouDialogComponent extends AbstractDialogComponent implements OnInit {
  defaultMessage = 'Thank you for submitting your proof';

  constructor(public activeModal: NgbActiveModal, public activityStore: ActivityStoreService) {
    super();
  }

  ngOnInit(): void {
    this.fireConfetti();
  }

  onClose(): void {
    this.activeModal.close();
  }

  fireConfetti() {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    confetti({
      position: { x: centerX, y: centerY },
    });
  }
}
